var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8108 0.180807C8.05975 0.425124 8.06351 0.825 7.81919 1.07395L4.88455 4.0643L7.693 6.92605C7.93731 7.175 7.93356 7.57488 7.6846 7.81919C7.43565 8.06351 7.03577 8.05975 6.79145 7.8108L3.99965 4.966L1.20855 7.81008C0.96423 8.05903 0.564354 8.06279 0.3154 7.81847C0.0664449 7.57416 0.0626855 7.17428 0.307003 6.92533L3.11474 4.0643L0.180807 1.07467C-0.0635106 0.825719 -0.0597512 0.425843 0.189203 0.181526C0.438158 -0.0627912 0.838034 -0.0590318 1.08235 0.189923L3.99965 3.16259L6.91765 0.189204C7.16197 -0.0597512 7.56184 -0.0635106 7.8108 0.180807Z",
    fill: "#62656E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.a75db60af6e922bcb2ceb723feafada6.svg";
export { ForwardRef as ReactComponent };